import { render, staticRenderFns } from "./EsButton.vue?vue&type=template&id=673989a4"
import script from "./EsButton.vue?vue&type=script&lang=js"
export * from "./EsButton.vue?vue&type=script&lang=js"
import style0 from "./EsButton.vue?vue&type=style&index=0&id=673989a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports